<template>
  <el-container style="padding-left: 3px;padding-bottom: 0px;padding-top: 0px;padding-right: 0px; height: 100%;" id="app">
    <el-aside width="500px">
      <el-form ref="form" :model="formData" label-width="140px" :label-position="labelPosition" :size="formSize"
               style="max-width:500px;">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="主界面内容" v-if="showPropGroups.includes('100')" name="100">
            <el-form-item label="文字内容" v-if="!hiddenPropIds.includes('1001')"> <!--文字内容-->
              <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;">
                <el-input type="textarea" placeholder="" v-model="formData.value_1001" :readonly="true"/>&nbsp;
                <el-button type="primary" @click="modifyContent()">修改</el-button>
              </div>
            </el-form-item>

            <el-form-item label="拼音" v-if="!hiddenPropIds.includes('1002')"> <!--拼音内容-->
              <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;">
                <el-input type="textarea" placeholder="" v-model="formData.value_1002" :readonly="true"/>&nbsp;
                <el-button type="primary" @click="pinyinDialogVisible=true">修改</el-button>
              </div>
            </el-form-item>

            <el-form-item label="组词" v-if="!hiddenPropIds.includes('1003')"> <!--组词内容-->
              <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;">
                <el-input type="textarea" placeholder="" v-model="formData.value_1003" :readonly="true"/>&nbsp;
                <el-button type="primary" @click="zuciDialogVisible=true">修改</el-button>
              </div>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1004')"> <!--字体-->
              <el-select v-model="formData.value_1004" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="字体大小" v-if="!hiddenPropIds.includes('1005')"> <!--字体-->
              <el-select v-model="formData.value_1005" placeholder="请选择字体大小">
                <el-option v-for="(item,index) in fontSizes" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="字体颜色" v-if="!hiddenPropIds.includes('1006')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1006"></el-color-picker>
            </el-form-item>

            <el-form-item label="第二字体颜色" v-if="!hiddenPropIds.includes('1007')"> <!--第二字体颜色-->
              <el-color-picker v-model="formData.value_1007"></el-color-picker>
            </el-form-item>

            <el-form-item label="格子样式" v-if="!hiddenPropIds.includes('1008')"> <!--田字格类型-->
              <div id="tzgDivMain" @click="selectTzg('main')">
                <svg width="80px" height="80px">
                  <g>
                    <path d="M0 0.5 L80 0.5" stroke="red" stroke-width="1" fill-opacity="0" position="top"/>
                    <path d="M79.5 0 L79.5 80" stroke="red" stroke-width="1" fill-opacity="0" position="right"/>
                    <path d="M80 79.5 L0 79.5" stroke="red" stroke-width="1" fill-opacity="0" position="bottom"/>
                    <path d="M0.5 0 L0.5 80" stroke="red" stroke-width="1" fill-opacity="0" position="left"/>
                    <path d="M1 40 L80 40" stroke-dasharray="4,4" stroke-width="0.5" stroke="red" fill-opacity="0"/>
                    <path d="M40 1 L40 80" stroke-dasharray="4,4" stroke-width="0.5" stroke="red" fill-opacity="0"/>
                  </g>
                </svg>
              </div>
            </el-form-item>

            <el-form-item label="田格子颜色" v-if="!hiddenPropIds.includes('1009')"> <!--格子颜色-->
              <el-color-picker v-model="formData.value_1009"></el-color-picker>
            </el-form-item>

            <el-form-item label="是否填充空白格子" v-if="!hiddenPropIds.includes('1011')"> <!--填充空白-->
              <el-switch v-model="formData.value_1011"></el-switch>
            </el-form-item>

            <el-form-item label="大字颜色" v-if="!hiddenPropIds.includes('1012')"> <!--大字颜色-->
              <el-color-picker v-model="formData.value_1012"></el-color-picker>
            </el-form-item>

          </el-collapse-item>
          <el-collapse-item title="拼音" v-if="showPropGroups.includes('103')" name="103">
            <el-form-item label="是否显示拼音" v-if="!hiddenPropIds.includes('1031')"> <!--是否显示拼音-->
              <el-switch v-model="formData.value_1031"></el-switch>
            </el-form-item>

            <el-form-item label="拼音颜色" v-if="!hiddenPropIds.includes('1032')"> <!--拼音颜色-->
              <el-color-picker v-model="formData.value_1032"></el-color-picker>
            </el-form-item>

            <el-form-item label="拼音格子类型" v-if="!hiddenPropIds.includes('1033')"> <!--田字格类型-->
              <div id="pyDivMain" @click="selectPy('py')">
                <svg width="80px" height="80px">
                  <g>
                    <path d="M0 0.5 L79.5 0.5" stroke="red" stroke-width="1" fill-opacity="0" position="top"/>
                    <path d="M79.5 0 L79.5 44.5" stroke="red" stroke-width="1" fill-opacity="0" position="right"/>
                    <path d="M79.5 44.5 L0 44.5" stroke="red" stroke-width="1" fill-opacity="0" position="bottom"/>
                    <path d="M0.5 0 L0.5 44.5" stroke="red" stroke-width="1" fill-opacity="0" position="left"/>
                    <path d="M2 15 L79.5 15" stroke-dasharray="4,4" stroke-width="0.25" stroke="red" fill-opacity="0"/>
                    <path d="M2 30 L79.5 30" stroke-dasharray="4,4" stroke-width="0.25" stroke="red" fill-opacity="0"/>
                  </g>
                </svg>
              </div>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1034')"> <!--字体-->
              <el-select v-model="formData.value_1034" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="控笔" v-if="showPropGroups.includes('104')" name="104">
            <el-form-item label="格子样式" v-if="!hiddenPropIds.includes('1041')"> <!--控笔格子类型-->
              <div id="tzgDivKb" @click="selectTzg('kb')">
                <svg width="80px" height="80px">
                  <g>
                    <path d="M0 0.5 L80 0.5" stroke="red" stroke-width="1" fill-opacity="0" position="top"/>
                    <path d="M79.5 0 L79.5 80" stroke="red" stroke-width="1" fill-opacity="0" position="right"/>
                    <path d="M80 79.5 L0 79.5" stroke="red" stroke-width="1" fill-opacity="0" position="bottom"/>
                    <path d="M0.5 0 L0.5 80" stroke="red" stroke-width="1" fill-opacity="0" position="left"/>
                    <path d="M1 40 L80 40" stroke-dasharray="4,4" stroke-width="0.5" stroke="red" fill-opacity="0"/>
                    <path d="M40 1 L40 80" stroke-dasharray="4,4" stroke-width="0.5" stroke="red" fill-opacity="0"/>
                  </g>
                </svg>
              </div>
            </el-form-item>

            <el-form-item label="格子颜色" v-if="!hiddenPropIds.includes('1042')"> <!--控笔格子颜色-->
              <el-color-picker v-model="formData.value_1042"></el-color-picker>
            </el-form-item>

            <el-form-item label="内容颜色" v-if="!hiddenPropIds.includes('1043')"> <!--控笔内容颜色-->
              <el-color-picker v-model="formData.value_1043"></el-color-picker>
            </el-form-item>

            <el-form-item label="格子行数" v-if="!hiddenPropIds.includes('1044')"> <!--控笔格子行数-->
              <el-select v-model="formData.value_1044" placeholder="请选择行数">
                <el-option v-for="(item,index) in rowCount" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="控笔内容" v-if="!hiddenPropIds.includes('1045')"> <!--控笔内容-->
              <el-input type="textarea" placeholder="" v-model="formData.value_1045"/>
            </el-form-item>

            <el-form-item label="重复次数" v-if="!hiddenPropIds.includes('1046')"> <!--重复次数-->
              <el-select v-model="formData.value_1046" placeholder="请选择">
                <el-option v-for="(item,index) in repeatCount" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="空白格子数" v-if="!hiddenPropIds.includes('1047')"> <!--空白格子数-->
              <el-select v-model="formData.value_1047" placeholder="请选择">
                <el-option v-for="(item,index) in emptyGeziCount" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="笔画" v-if="showPropGroups.includes('105')" name="105">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1050')"> <!--是否显示笔画-->
              <el-switch v-model="formData.value_1050"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1051')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1051"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1052')"> <!--字体-->
              <el-select v-model="formData.value_1052" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="结构" v-if="showPropGroups.includes('107')" name="107">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1070')"> <!--是否显示结构-->
              <el-switch v-model="formData.value_1070"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1071')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1071"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1072')"> <!--字体-->
              <el-select v-model="formData.value_1072" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="部首" v-if="showPropGroups.includes('109')" name="109">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1090')"> <!--是否显示部首-->
              <el-switch v-model="formData.value_1090"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1091')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1091"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1092')"> <!--字体-->
              <el-select v-model="formData.value_1092" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="笔顺" v-if="showPropGroups.includes('110')" name="110">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1100')"> <!--是否显示笔顺-->
              <el-switch v-model="formData.value_1100"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1101')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1101"></el-color-picker>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="组词" v-if="showPropGroups.includes('111')" name="111">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1110')"> <!--是否显示组词-->
              <el-switch v-model="formData.value_1110"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1111')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1111"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1112')"> <!--字体-->
              <el-select v-model="formData.value_1112" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="标题-" v-if="showPropGroups.includes('112')" name="112">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1120')"> <!--是否显示标题-->
              <el-switch v-model="formData.value_1120"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1121')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1121"></el-color-picker>
            </el-form-item>

            <el-form-item label="内容" v-if="!hiddenPropIds.includes('1122')"> <!--标题内容-->
              <el-input placeholder="" v-model="formData.value_1122"/>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1123')"> <!--字体-->
              <el-select v-model="formData.value_1123" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="对齐方式" v-if="!hiddenPropIds.includes('1124')"> <!--字体-->
              <el-select v-model="formData.value_1124" placeholder="请选择对齐方式">
                <el-option v-for="item in alignType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="字体大小" v-if="!hiddenPropIds.includes('1125')"> <!--字体大小-->
              <el-select v-model="formData.value_1125" placeholder="请选择字体大小">
                <el-option v-for="(item,index) in fontSizes" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="班级" v-if="showPropGroups.includes('113')" name="113">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1130')"> <!--是否显示班级-->
              <el-switch v-model="formData.value_1130"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1131')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1131"></el-color-picker>
            </el-form-item>

            <el-form-item label="内容" v-if="!hiddenPropIds.includes('1132')"> <!--班级内容-->
              <el-input placeholder="" v-model="formData.value_1132"/>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1133')"> <!--字体-->
              <el-select v-model="formData.value_1133" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="字体大小" v-if="!hiddenPropIds.includes('1134')"> <!--字体大小-->
              <el-select v-model="formData.value_1134" placeholder="请选择字体大小">
                <el-option v-for="(item,index) in fontSizes" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="姓名" v-if="showPropGroups.includes('114')" name="114">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1140')"> <!--是否显示姓名-->
              <el-switch v-model="formData.value_1140"></el-switch>
            </el-form-item>

            <el-form-item label="姓名内容" v-if="!hiddenPropIds.includes('1141')"> <!--姓名内容-->
              <el-input placeholder="" v-model="formData.value_1141"/>
            </el-form-item>

            <el-form-item label="姓名长度" v-if="!hiddenPropIds.includes('1142')"> <!--姓名长度-->
              <el-select v-model="formData.value_1142" placeholder="请选择姓名长度">
                <el-option v-for="(item,index) in nameLength" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="格子样式" v-if="!hiddenPropIds.includes('1143')"> <!--格子类型-->
              <div id="tzgDivName" @click="selectTzg('name')">
                <svg width="80px" height="80px">
                  <g>
                    <path d="M0 0.5 L80 0.5" stroke="red" stroke-width="1" fill-opacity="0" position="top"/>
                    <path d="M79.5 0 L79.5 80" stroke="red" stroke-width="1" fill-opacity="0" position="right"/>
                    <path d="M80 79.5 L0 79.5" stroke="red" stroke-width="1" fill-opacity="0" position="bottom"/>
                    <path d="M0.5 0 L0.5 80" stroke="red" stroke-width="1" fill-opacity="0" position="left"/>
                    <path d="M1 40 L80 40" stroke-dasharray="4,4" stroke-width="0.5" stroke="red" fill-opacity="0"/>
                    <path d="M40 1 L40 80" stroke-dasharray="4,4" stroke-width="0.5" stroke="red" fill-opacity="0"/>
                  </g>
                </svg>
              </div>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1144')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1144"></el-color-picker>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="评价" v-if="showPropGroups.includes('115')" name="115">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1150')"> <!--是否显示评价-->
              <el-switch v-model="formData.value_1150"></el-switch>
            </el-form-item>

            <el-form-item label="内容" v-if="!hiddenPropIds.includes('1151')"> <!--评价内容-->
              <el-input placeholder="" v-model="formData.value_1151"/>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1152')"> <!--字体-->
              <el-select v-model="formData.value_1152" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1153')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1153"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1154')"> <!--字体-->
              <el-select v-model="formData.value_1154" placeholder="请选择字体大小">
                <el-option v-for="(item,index) in fontSizes" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="页码" v-if="showPropGroups.includes('117')" name="117">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1170')"> <!--是否显示页码-->
              <el-switch v-model="formData.value_1170"></el-switch>
            </el-form-item>

            <el-form-item label="内容" v-if="!hiddenPropIds.includes('1171')"> <!--页码内容-->
              <el-input placeholder="" v-model="formData.value_1171"/>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1172')"> <!--字体-->
              <el-select v-model="formData.value_1172" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1173')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1173"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1174')"> <!--字体-->
              <el-select v-model="formData.value_1174" placeholder="请选择字体大小">
                <el-option v-for="(item,index) in fontSizes" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="二维码" v-if="showPropGroups.includes('120')" name="120">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1200')"> <!--是否显示页码-->
              <el-switch v-model="formData.value_1200"></el-switch>
            </el-form-item>

            <el-form-item label="二维码URL" v-if="!hiddenPropIds.includes('1201')"> <!--二维码URL-->
              <el-input placeholder="" v-model="formData.value_1201"/>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="左下角" v-if="showPropGroups.includes('121')" name="121">
            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1210')"> <!--是否显示左下角内容-->
              <el-switch v-model="formData.value_1210"></el-switch>
            </el-form-item>

            <el-form-item label="左下角内容" v-if="!hiddenPropIds.includes('1211')"> <!--左下角内容-->
              <el-input placeholder="" v-model="formData.value_1211"/>
            </el-form-item>

            <el-form-item label="字体" v-if="!hiddenPropIds.includes('1212')"> <!--字体-->
              <el-select v-model="formData.value_1212" placeholder="请选择字体">
                <el-option v-for="(item,index) in fontFamilys" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1213')"> <!--字体颜色-->
              <el-color-picker v-model="formData.value_1213"></el-color-picker>
            </el-form-item>

            <el-form-item label="字体大小" v-if="!hiddenPropIds.includes('1214')"> <!--字体大小-->
              <el-select v-model="formData.value_1214" placeholder="请选择字体大小">
                <el-option v-for="(item,index) in fontSizes" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

          <el-collapse-item title="边框" v-if="showPropGroups.includes('122')" name="122">
            <el-form-item label="页边距" v-if="!hiddenPropIds.includes('1221')"> <!--页边距-->
              <el-select v-model="formData.value_1221" placeholder="请选择页边距">
                <el-option v-for="item in pageMargin" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否显示" v-if="!hiddenPropIds.includes('1222')"> <!--是否显示边框-->
              <el-switch v-model="formData.value_1222"></el-switch>
            </el-form-item>

            <el-form-item label="颜色" v-if="!hiddenPropIds.includes('1223')"> <!--边框颜色-->
              <el-color-picker v-model="formData.value_1223"></el-color-picker>
            </el-form-item>

            <el-form-item label="边框宽度" v-if="!hiddenPropIds.includes('1224')"> <!--边框宽度-->
              <el-select v-model="formData.value_1224" placeholder="请选择字体大小">
                <el-option v-for="(item,index) in borderWidth" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-collapse-item>

        </el-collapse>
      </el-form>
    </el-aside>
    <el-main style="padding: 10px;">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-button type="primary" @click="previewPdf()">预 览</el-button>
          <el-button type="primary" @click="generatePdfFile()">生成 PDF</el-button>


          <el-link class="downloadLink" v-if="showDownloadHref" :href="downloadPdfHref" target="_blank"
                   id="downloadElLink" ref="downloadElLinkRef">点击此处下载PDF文件
          </el-link>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col>
          <div id="previewImage" v-if="isShowPreviewImage" style="margin-top: 10px;">
            <div style="font-size:20px">模板示例</div>
            <el-image class="preview_img" :src="require('../images/'+ this.$route.query.templateId+'_big.png')"/>
          </div>

          <div id="previewSvg" v-if="isShowPreviewPdf" style="margin-top: 10px;">

          </div>
        </el-col>
      </el-row>
    </el-main>

    <el-dialog title="选择田字格" :visible="selectTzgDialogVisible" width="850px" @opened="addAllTzgSvgEle()"
               @close="selectTzgDialogVisible = false">
      <el-scrollbar>
        <div style="height:500px">
          <el-radio-group v-model="tzgRadioSelectId">
            <div class="svg_div_item" v-for="(item,index) in tzgSvg" :key="item.id" style="margin:3px">
              <div :id="getTzgDivId(index)" :ref="'tzgSvg'+index">
              </div>
              <div class="item-title">
                <el-radio :label="item.id">{{ item.cnName }}</el-radio>
              </div>
            </div>
          </el-radio-group>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectTzgDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="tzgDialogConfirm()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择拼音格" :visible="selectPyDialogVisible" width="850px" @opened="addAllPySvgEle()"
               @close="selectPyDialogVisible = false">
      <el-scrollbar>
        <div style="height:500px">
          <el-radio-group v-model="pyRadioSelectId">
            <div class="svg_div_item" v-for="(item,index) in pinyinSvg" :key="item.id" style="margin:3px">
              <div :id="getPyDivId(index)" :ref="'pySvg'+index">
              </div>
              <div class="item-title">
                <el-radio :label="item.id">{{ item.cnName }}</el-radio>
              </div>
            </div>
          </el-radio-group>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectPyDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="pyDialogConfirm()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="输入内容" :visible="inputContentDialogVisible" width="850px"
               @close="inputContentDialogVisible=false">
      <el-form ref="form" :model="contentFormData" label-width="120px" :label-position="labelPosition" :size="formSize"
               style="max-width:500px;">
        <el-form-item label="文字内容"> <!--文字内容-->
          <el-input type="textarea" placeholder="请输入汉字" v-model="contentFormData.text_content" :rows="8" style="width: 660px;"/>
        </el-form-item>

        <el-form-item label=""> <!--选择字库-->
          <el-button @click="bookSelectDialogVisible = true">选择字库</el-button>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="inputContentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="inputContentDialogConfirm()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择字库" :visible="bookSelectDialogVisible" width="850px"
               @close="bookSelectDialogVisible=false">
      <el-form ref="form" :model="bookFormData" label-width="120px" :label-position="labelPosition" :size="formSize"
               style="max-width:800px;">
        <el-form-item label="年级"> <!--班级-->
          <el-tag v-for="item in classList" :key="item.classNa" :type="item.elTagType"
                  style="margin:5px" @click="selectOneClass(item.classNa)" effect="dark">{{ item.classNa }}
          </el-tag>
        </el-form-item>

        <el-form-item label="上下册"> <!--上下册-->
          <el-tag v-for="item in bookNames" :key="item.name" :type="item.elTagType"
                  style="margin:5px" @click="selectOneBook(item.name)" effect="dark">{{ item.name }}
          </el-tag>
        </el-form-item>

        <el-form-item label="内容类型"> <!--章节类型-->
          <el-tag v-for="item in chapterTypes" :key="item.chapterType" :type="item.elTagType"
                  style="margin:5px" @click="selectOneChapter(item.chapterType)" effect="dark">{{ item.chapterType }}
          </el-tag>
        </el-form-item>

        <el-form-item label="内容"> <!--章节类型-->
          <el-table ref="multipleTable" v-if="contentTableVisible==true" :data="chapterContents" tooltip-effect="dark"
                    style="width: 100%" @selection-change="handleContentRowSelect" border height="350">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              prop="chapterName"
              label="姓名"
              width="120">
            </el-table-column>
            <el-table-column
              prop="textContent"
              label="地址">
            </el-table-column>
          </el-table>
        </el-form-item>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bookSelectDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="zikuDialogConfirm()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择拼音" :visible="pinyinDialogVisible" width="850px" @close="pinyinDialogVisible=false">
      <div style="height:500px; overflow-y: auto">
        <el-form ref="form" :model="pinyinFormData" label-width="80px" :label-position="labelPosition" :size="formSize"
                 style="max-width:800px;">
          <el-form-item v-for="item in wordInfo" :key="item.id" :label="item.chineseChar"
                        v-if="item.pinyinList!=null && item.pinyinList.length>0">
            <el-tag v-for="(pinyin,index) in item.pinyinList" :key="pinyin.pinyin" :type="pinyin.elTagType"
                    style="margin-left:5px;margin-right:5px;margin-top:3px;margin-botom:3px;width:80px;font-size: 16px;" @click="selectPinyin(item.id,index)" effect="dark">{{ pinyin.pinyin }}
            </el-tag>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="pinyinDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择组词" :visible="zuciDialogVisible" width="850px"
               @close="zuciDialogVisible=false">
      <div style="height:500px; overflow-y: auto">
        <el-form ref="form" :model="zuciFormData" label-width="80px" :label-position="labelPosition" :size="formSize"
                 style="max-width:800px;">
          <el-form-item v-for="item in wordInfo" :key="item.id" :label="item.chineseChar"
                        v-if="item.zuciList!=null && item.zuciList.length>0">
            <el-tag v-for="(zuci,index) in item.zuciList" :key="zuci.zuci" :type="zuci.elTagType"
                    style="margin:5px" @click="selectZuci(item.id,index)" effect="dark">{{ zuci.zuci }}
            </el-tag>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="zuciDialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </el-container>
</template>

<script>
import axios from "axios";
import qs from 'qs';
import pako from 'pako'

export default {
  name: "userData",
  data() {
    return {
      loadingDialog: null,//loading dialog对象
      pdfUuid: null,//pdf文件的uuid
      showDownloadHref: false,//是否显示下载的链接
      downloadPdfHref: null,//下载pdf的链接
      isShowPreviewImage: true,//是否显示预览的图片
      isShowPreviewPdf: false,//是否显示预览的pdf
      isRoot: false,
      isSeleClass: false,
      labelPosition: 'left',
      formSize: 'small',
      selectTzgDialogVisible: false,
      selectPyDialogVisible: false,
      inputContentDialogVisible: false,
      bookSelectDialogVisible: false,
      pinyinDialogVisible: false,
      zuciDialogVisible: false,
      isAddedTzgSvg: false,//是否已增加了svg元素
      isAddedPySvg: false,//是否已增加了svg元素
      rowCount: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],//控笔格子行数
      repeatCount: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],//控笔重复次数
      emptyGeziCount: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],//空白格子数
      borderWidth: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],//边框宽度
      alignType: [{value: 'LEFT', label: '左'}, {value: 'CENTER', label: '中'}, {value: 'RIGHT', label: '右'}],//对齐方式
      nameLength: [2, 3, 4, 5, 6],//姓名长度
      pageMargin: [{value: 'COMMON', label: '普通'},
        {value: 'NARROW', label: '窄'},
        {value: 'MODERATE', label: '适中'},
        {value: 'WIDE', label: '宽'}],//页边距设置
      activeNames: ['100'],
      tzgRadioSelectId: 1,
      pyRadioSelectId: 1,
      currTzgType: null,//当前点击的是哪一个选田字格的元素
      currPyType: null,//当前点击的是哪一个选田字格的元素
      // activeNames: ['100', '103', '104', '105', '107', '109', '110', '111', '112', '113', '114', '115', '117', '120', '121', '122'],
      // 字体
      fontFamilys: ['Arial', 'Helvetica', 'Verdana', 'Tahoma', 'Georgia', 'Times New Roman', 'Courier New', 'Impact', 'Lucida Sans Unicode', '宋体', '黑体', '微软雅黑', '楷体', '仿宋', '楷体_GB2312', '新宋体', '隶书', '幼圆', '华文行楷', '华文中宋', '华文新魏', '华文隶书', '华文楷体', '华文仿宋', '方正舒体', '方正姚体', '华文彩云', '华文琥珀'],
      // 字体大小
      fontSizes: ['16', '18', '20', '22', '24', '26', '28', '30', '32', '34', '36', '38', '40', '42', '44', '46', '48', '50', '52', '54', '56', '58', '60', '62', '64', '66', '68', '70', '72', '74', '76', '78', '80'],

      // 控制是否显示
      showPropGroups: [],
      hiddenPropIds: null,
      formData: {
        value_1001: '',
        value_1002: '',
        value_1003: '',
        value_1004: '',
        value_1005: '',
        value_1006: '',
        value_1007: '',
        value_1008: '',
        value_1009: '',
        value_1011: '',
        value_1012: '',

        value_1031: '',
        value_1032: '',
        value_1033: '',
        value_1034: '',

        value_1041: '',
        value_1042: '',
        value_1043: '',
        value_1044: '',
        value_1045: '',
        value_1046: '',
        value_1047: '',

        value_1050: '',
        value_1051: '',
        value_1052: '',

        value_1070: '',
        value_1071: '',
        value_1072: '',

        value_1090: '',
        value_1091: '',
        value_1092: '',

        value_1100: '',
        value_1101: '',

        value_1110: '',
        value_1111: '',
        value_1112: '',

        value_1120: '',
        value_1121: '',
        value_1122: '',
        value_1123: '',
        value_1124: '',
        value_1125: '',

        value_1130: '',
        value_1131: '',
        value_1132: '',
        value_1133: '',
        value_1134: '',

        value_1140: '',
        value_1141: '',
        value_1142: '',
        value_1143: '',
        value_1144: '',

        value_1150: '',
        value_1151: '',
        value_1152: '',
        value_1153: '',
        value_1154: '',

        value_1170: '',
        value_1171: '',
        value_1172: '',
        value_1173: '',
        value_1174: '',

        value_1200: '',
        value_1201: '',

        value_1210: '',
        value_1211: '',
        value_1212: '',
        value_1213: '',
        value_1214: '',

        value_1220: '',
        value_1221: '',
        value_1222: '',
        value_1223: '',
        value_1224: '',

        templateId: '',
        wordInfo: null,
      },
      contentFormData: {
        text_content: '',
      },
      contentTableVisible: false,
      bookFormData: {},
      pinyinFormData: {},
      zuciFormData: {},
      tzgSvg: [],
      pinyinSvg: [],
      bookInfo: null,
      wordInfo: null,
      classList: [],
      bookNames: [
        {
          name: '上册',
          selected: false,
          elTagType: 'info'
        },
        {
          name: '下册',
          selected: false,
          elTagType: 'info'
        }],
      chapterTypes: [],//章节
      chapterContents: [],//章节内容
      selectTableRows: null,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
    };
  },
  created() {
  },
  methods: {
    // load pdf prop default value
    loadPdfDefProps() {
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/getPdfDefaultPropValue.do"
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.formData = resp.data.data;
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    loadTzgSvg() {
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/getTzgSvg.do"
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.tzgSvg = resp.data.data;
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    loadPinyinSvg() {
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/getPinyinSvg.do"
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.pinyinSvg = resp.data.data;
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    loadShowProps() {
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/getTzgShowProps.do",
        params: {
          templateId: this.$route.query.templateId
        }
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.showPropGroups = resp.data.data.showGroupIdList;
          this.hiddenPropIds = resp.data.data.hiddenPropIds;
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    // 弹出dialog选择田字格类型
    selectTzg(area) {
      this.currTzgType = area;
      if (this.currTzgType == "main") {
        this.tzgRadioSelectId = this.formData.value_1008;
      } else if (this.currTzgType == "py") {
        this.tzgRadioSelectId = this.formData.value_1033;
      } else if (this.currTzgType == "kb") {
        this.tzgRadioSelectId = this.formData.value_1041;
      } else if (this.currTzgType == "name") {
        this.tzgRadioSelectId = this.formData.value_1143;
      }

      this.selectTzgDialogVisible = true;
    },
    selectPy(area) {
      if (this.currPyType == "py") {
        this.pyRadioSelectId = this.formData.value_1033;
      }

      this.selectPyDialogVisible = true;
    },
    getTzgDivId(index) {
      return "tzgSvg" + index;
    },
    getPyDivId(index) {
      return "pySvg" + index;
    },
    addAllTzgSvgEle() {
      if (this.isAddedTzgSvg) {
        return;
      }

      var that = this;
      var refs = that.$refs;

      var svgCount = 0;
      for (var key in refs) {
        if (key.indexOf("tzgSvg") == 0) {
          var svgEle = this.$refs[`tzgSvg${svgCount}`];
          svgEle[0].insertAdjacentHTML("afterbegin", this.tzgSvg[svgCount].svgCode);
          svgEle[0].firstChild.style.width = "80px";
          svgEle[0].firstChild.style.height = "80px";
          svgCount++;
        }
      }

      this.isAddedTzgSvg = true;
    },
    addAllPySvgEle() {
      if (this.isAddedPySvg) {
        return;
      }

      var that = this;
      var refs = that.$refs;

      var svgCount = 0;
      for (var key in refs) {
        if (key.indexOf("pySvg") == 0) {
          var svgEle = this.$refs[`pySvg${svgCount}`];
          svgEle[0].insertAdjacentHTML("afterbegin", this.pinyinSvg[svgCount].svgCode);
          svgEle[0].firstChild.style.width = "80px";
          svgEle[0].firstChild.style.height = "80px";
          svgCount++;
        }
      }

      this.isAddedPySvg = true;
    },
    tzgDialogConfirm() {//田字格选择界面的confirm按钮
      this.selectTzgDialogVisible = false;

      var parentDivEle = null;
      if (this.currTzgType == "main") {
        this.formData.value_1008 = this.tzgRadioSelectId;
        parentDivEle = document.querySelector('#tzgDivMain');
      } else if (this.currTzgType == "kb") {
        this.formData.value_1041 = this.tzgRadioSelectId;
        parentDivEle = document.querySelector('#tzgDivKb');
      } else if (this.currTzgType == "name") {
        this.formData.value_1143 = this.tzgRadioSelectId;
        parentDivEle = document.querySelector('#tzgDivName');
      }

      for (var i = 0; i < this.tzgSvg.length; i++) {
        if (this.tzgSvg[i].id == this.tzgRadioSelectId) {
          parentDivEle.removeChild(parentDivEle.childNodes[0]);
          parentDivEle.insertAdjacentHTML("afterbegin", this.tzgSvg[i].svgCode);
          parentDivEle.firstChild.style.width = "80px";
          parentDivEle.firstChild.style.height = "80px";

          break;
        }
      }
    },
    pyDialogConfirm() {//拼音格选择界面的confirm按钮
      this.selectPyDialogVisible = false;

      this.formData.value_1033 = this.pyRadioSelectId;
      var parentDivEle = document.querySelector('#pyDivMain');

      for (var i = 0; i < this.pinyinSvg.length; i++) {
        if (this.pinyinSvg[i].id == this.pyRadioSelectId) {
          parentDivEle.removeChild(parentDivEle.childNodes[0]);
          parentDivEle.insertAdjacentHTML("afterbegin", this.pinyinSvg[i].svgCode);
          parentDivEle.firstChild.style.width = "80px";
          parentDivEle.firstChild.style.height = "80px";

          break;
        }
      }
    },
    previewPdf() {//预览pdf
      if (!this.checkInputValid()) {
        return;
      }

      this.isShowPreviewImage = false;
      this.isShowPreviewPdf = true;
      this.showDownloadHref = false;
      this.formData.templateId = this.$route.query.templateId;
      this.formData.wordInfo = JSON.stringify(this.wordInfo);
      this.saveConfigData();

      axios({
        method: 'post',
        headers: {'Content-type': 'application/x-www-form-urlencoded'},
        dataType: 'json',
        data: qs.stringify(this.formData),
        url: this.$globalMsg.hostUrl + "tzg/previewPdf.do",
        withCredentials: true // 允许携带cookie
      }).then(resp => {
        if (resp.data.retCode == "00") {
          var svgData = resp.data.data;
          var decompress = this.unzip(svgData);

          document.getElementById("previewSvg").innerHTML = "";
          document.getElementById("previewSvg").innerHTML = decompress;
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    generatePdfFile() {//生成pdf文件
      if (!this.checkInputValid()) {
        return;
      }

      this.isShowPreviewImage = false;
      this.showDownloadHref = false;
      this.formData.templateId = this.$route.query.templateId;
      this.formData.wordInfo = JSON.stringify(this.wordInfo);
      this.saveConfigData();

      axios({
        method: 'post',
        headers: {'Content-type': 'application/x-www-form-urlencoded'},
        dataType: 'json',
        data: qs.stringify(this.formData),
        url: this.$globalMsg.hostUrl + "tzg/generatePdfFile.do",
        withCredentials: true // 允许携带cookie
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.pdfUuid = resp.data.data;
          this.showLoading();
          setTimeout(() => {
            this.checkPdfIsGenerated();
          }, 2000);
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    checkInputValid() {//检查输入是否合法
      if (this.formData.value_1001 == null || this.formData.value_1001 == "" || this.wordInfo == null || this.wordInfo.length == 0) {
        this.$message.error("请输入内容");
        return false;
      }

      var hasValidChar = false;
      for (var i = 0; i < this.wordInfo.length; i++) {
        var pinyinList = this.wordInfo[i].pinyinList;
        if (pinyinList.length > 0) {
          hasValidChar = true;
          break;
        }
      }
      if (!hasValidChar) {
        this.$message.error("请输入内容");
      }

      return hasValidChar;
    },
    checkPdfIsGenerated() {
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/checkPdfIsGenerated.do",
        params: {
          pdfUuid: this.pdfUuid
        }
      }).then(resp => {
        if (resp.data.retCode == "00") {
          var genStatus = resp.data.data.fileStatus;
          if (genStatus == "SUCCESS") {
            this.closeLoading();
            this.$message.success("文件生成成功,点击链接可以下载文件");
            this.downloadPdf();
          } else if (genStatus == "NEW") {
            setTimeout(() => {
              this.checkPdfIsGenerated();
            }, 1000);
          } else if (genStatus == "FAIL") {
            this.closeLoading();
            this.$message.error("生成pdf文件失败");
          }
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    showLoading() {//显示loading框
      this.loadingDialog = this.$loading({
        lock: true,
        text: '生成中，请耐心等待3至10秒钟...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    closeLoading() {//关闭loading框
      this.loadingDialog.close();
    },
    downloadPdf() {
      this.downloadPdfHref = this.$globalMsg.hostUrl + "tzg/downloadPdfFile.do?pdfUuid=" + this.pdfUuid;
      this.showDownloadHref = true;
      // this.$refs.downloadElLinkRef.click();
      // this.$refs.downloadElLinkRef.click();
      // this.$refs.downloadElLinkRef.emit("click");
      // this.$refs.downloadElLinkRef.$el.click();
      // document.getElementById("downloadElLink").click();
    },
    saveConfigData() { //保存配置数据
      localStorage.setItem(this.getStorageKey(), qs.stringify(this.formData));
    },
    loadConfigData() {//加载配置数据
      var tzgConfig = localStorage.getItem(this.getStorageKey());
      if (tzgConfig == null || tzgConfig.length == 0) {
        return;
      }

      this.formData = qs.parse(tzgConfig);
    },
    getStorageKey() {//返回存储数据的key值
      return "tzgConfig_" + this.formData.templateId;
    },
    inputContentDialogConfirm() {//输入内容之后的confirm
      if (this.contentFormData.text_content.length > 200) {
        this.$message.error("内容长度不能超过200!");
        return;
      }
      this.inputContentDialogVisible = false;
      this.formData.value_1001 = this.contentFormData.text_content;

      this.loadTextPinyin();
    },
    modifyContent() {//修改文字内容
      this.inputContentDialogVisible = true;
      this.contentFormData.text_content = this.formData.value_1001;
    },
    loadBookClass() {//查询书信息
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/selectAllChapterInfo.do",
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.bookInfo = resp.data.data;
          this.handleClassInfo();
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    handleClassInfo() {//处理班级信息
      var uniqueClass = new Array();
      for (var i = 0; i < this.bookInfo.length; i++) {
        var currClass = this.bookInfo[i].className;
        var isFindClass = false;
        for (var j = 0; j < uniqueClass.length; j++) {
          if (currClass == uniqueClass[j]) {
            isFindClass = true;
            break;
          }
        }

        if (!isFindClass) {
          uniqueClass[uniqueClass.length] = currClass;
        }
      }

      for (var i = 0; i < uniqueClass.length; i++) {
        this.classList.push({classNa: uniqueClass[i], selected: false, elTagType: 'info'});
      }
    },
    selectOneClass(selectedClass) {//选中一个班级
      for (var i = 0; i < this.classList.length; i++) {
        this.classList[i].selected = this.classList[i].classNa == selectedClass;
        this.classList[i].elTagType = this.classList[i].selected ? 'success' : 'info';
      }

      for (var i = 0; i < this.bookNames.length; i++) {
        this.bookNames[i].selected = false;
        this.bookNames[i].elTagType = 'info';
      }

      this.chapterTypes = [];
      this.contentTableVisible = false;
    },
    selectOneBook(bookName) {
      for (var i = 0; i < this.bookNames.length; i++) {
        this.bookNames[i].selected = this.bookNames[i].name == bookName;
        this.bookNames[i].elTagType = this.bookNames[i].selected ? 'success' : 'info';
      }

      this.chapterTypes = [];
      var selectedBook = bookName;
      var selectedClass = null;
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].selected) {
          selectedClass = this.classList[i].classNa;
          break;
        }
      }

      for (var i = 0; i < this.bookInfo.length; i++) {
        if (this.bookInfo[i].className == selectedClass && this.bookInfo[i].bookName == selectedBook) {
          this.chapterTypes.push({chapterType: this.bookInfo[i].chapterType, selected: false, elTagType: 'info'});
        }
      }

      this.contentTableVisible = false;
    },
    selectOneChapter(chapterType) {//选中一个章节类型
      var selectedClass = null;
      for (var i = 0; i < this.classList.length; i++) {
        if (this.classList[i].selected) {
          selectedClass = this.classList[i].classNa;
          break;
        }
      }

      var selectedBook = null;
      for (var i = 0; i < this.bookNames.length; i++) {
        if (this.bookNames[i].selected) {
          selectedBook = this.bookNames[i].name;
          break;
        }
      }

      for (var i = 0; i < this.chapterTypes.length; i++) {
        this.chapterTypes[i].selected = this.chapterTypes[i].chapterType == chapterType;
        this.chapterTypes[i].elTagType = this.chapterTypes[i].selected ? 'success' : 'info';
      }

      this.contentTableVisible = true;
      this.loadChapterContent(selectedClass, selectedBook, chapterType);
    },
    loadChapterContent(classNa, book, chapterType) {//加载章节内容
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/loadChapterContent.do",
        params: {
          classNa: classNa,
          book: book,
          chapterType: chapterType
        }
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.chapterContents = resp.data.data;
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    handleContentRowSelect(val) {//选中表格的一行
      this.selectTableRows = val;
    },
    zikuDialogConfirm() {//字库确定
      var contents = "";
      for (var i = 0; i < this.selectTableRows.length; i++) {
        if (contents.length > 0) {
          contents += "\n";
        }
        contents += this.selectTableRows[i].textContent;
      }

      console.log("contents----"+contents);
      this.contentFormData.text_content = contents;
      this.bookSelectDialogVisible = false;
    },
    loadTextPinyin() {//加载拼音
      axios({
        method: 'get',
        url: this.$globalMsg.hostUrl + "tzg/getWordInfo.do",
        params: {
          textContent: this.formData.value_1001
        }
      }).then(resp => {
        if (resp.data.retCode == "00") {
          this.wordInfo = resp.data.data;
          this.handlePinyinInfo();
          this.handleZuciInfo();
        } else {
          this.$message.error(resp.data.retMsg);
        }
      })
    },
    handlePinyinInfo() {//处理拼音信息
      var showPinyin = "";
      for (var i = 0; i < this.wordInfo.length; i++) {
        var pinyinList = this.wordInfo[i].pinyinList;
        for (var j = 0; j < pinyinList.length; j++) {
          if (pinyinList[j].selected) {
            if (showPinyin.length > 0) {
              showPinyin += ",";
            }
            showPinyin += pinyinList[j].pinyin;
          }
        }
      }

      this.formData.value_1002 = showPinyin;
    },
    selectPinyin(itemId, index) {//选中一个拼音
      for (var i = 0; i < this.wordInfo.length; i++) {
        if (this.wordInfo[i].id == itemId) {
          for (var j = 0; j < this.wordInfo[i].pinyinList.length; j++) {
            if (j == index) {
              this.wordInfo[i].pinyinList[j].elTagType = 'success';
              this.wordInfo[i].pinyinList[j].selected = true;
            } else {
              this.wordInfo[i].pinyinList[j].elTagType = 'info';
              this.wordInfo[i].pinyinList[j].selected = false;
            }
          }
          break;
        }
      }

      this.handlePinyinInfo();
    },
    selectZuci(itemId, index) {//选中一个组词
      for (var i = 0; i < this.wordInfo.length; i++) {
        if (this.wordInfo[i].id == itemId) {

          var selectedCount = 0;
          for (var j = 0; j < this.wordInfo[i].zuciList.length; j++) {
            if (j == index) {
              var isSelected = this.wordInfo[i].zuciList[j].selected;
              this.wordInfo[i].zuciList[j].selected = !isSelected;
              if (isSelected) {
                this.wordInfo[i].zuciList[j].elTagType = 'info';
              } else {
                this.wordInfo[i].zuciList[j].elTagType = 'success';
              }
            }

            if (this.wordInfo[i].zuciList[j].selected) {
              selectedCount++;
            }
          }

          if (selectedCount > 4) {
            this.wordInfo[i].zuciList[index].selected = false;
            this.wordInfo[i].zuciList[index].elTagType = 'info';
            this.$message.error("每个汉字选中的词组不能超过4个!");
          }

          break;
        }
      }

      this.handleZuciInfo();
    },
    handleZuciInfo() {//处理组词信息
      var showZuci = "";
      for (var i = 0; i < this.wordInfo.length; i++) {
        var zuciList = this.wordInfo[i].zuciList;
        for (var j = 0; j < zuciList.length; j++) {
          if (zuciList[j].selected) {
            if (showZuci.length > 0) {
              showZuci += ",";
            }
            showZuci += zuciList[j].zuci;
          }
        }
      }

      this.formData.value_1003 = showZuci;
    },
    unzip(b64Data) {
      var strData = atob(b64Data);
      // 将二进制字符串转换为字符数数组
      var charData = strData.split("").map(function (x) {
        return x.charCodeAt(0);
      });
      // 把数字数组转换成字节数组
      var binData = new Uint8Array(charData);
      // 解压
      var data = pako.inflate(binData);
      //将解压缩完成的的byteArray转换回ascii字符串:
      var strData = new TextDecoder("utf-8").decode(data);//大数据使用此方法
      //var strData   = String.fromCharCode.apply(null, new Uint16Array(data));//数据不是很多可以使用此方法
      return decodeURIComponent(strData);
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.formData.templateId = this.$route.query.templateId;
      this.loadPdfDefProps();
      this.loadTzgSvg();
      this.loadPinyinSvg();
      this.loadShowProps();
      this.loadConfigData();
      this.loadBookClass();
    });
  }
};
</script>

<style scoped>
.svg_div_item {
  -webkit-box-shadow: 0px 0px 1px 1px #cccccc;
  -moz-box-shadow: 0px 0px 1px #cccccc;
  width: 150px;
  height: 150px;
  border-radius: 5px;
  display: inline-grid;
  justify-content: center;
  margin-left: 5px;
  margin-right: 5px;
  align-items: center;
  //margin-top: 5px;
  //margin-bottom: 5px;
}

.downloadLink {
  color: red;
}

// 折叠面板
/deep/ .el-collapse {
  background-color: #d0e2f4 !important;
  color: black;
}

/deep/ .el-collapse, .el-collapse-item__wrap {
  border: none;
  background-color: #d0e2f4 !important;
  color: black;
}

/deep/ .el-collapse-item__header {
  color: #fff;
  background-color: #d0e2f4 !important;
  color: black;
}

/deep/ .el-dialog__header {
  background-color: #d0e2f4 !important;
  color: black;
}

</style>



// WEBPACK FOOTER //
// src/components/templateEdit.vue